import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26371474"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary__total-products" }
const _hoisted_2 = { class: "summary__total-products--count" }
const _hoisted_3 = { class: "summary__total-products--price" }
const _hoisted_4 = { class: "summary__discount" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__discount--header" }, "Discount", -1 /* HOISTED */))
const _hoisted_6 = { class: "summary__discount--value" }

import { storeToRefs } from 'pinia';
import { usePromo, useCart } from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'PromoCommonInfo',
  setup(__props) {

const { totalProducts } = storeToRefs(useCart());
const { totalPrice, isDiscounted, getPromoPrice } = storeToRefs(usePromo());

return (_ctx: any,_cache: any) => {
  const _component_AppNumber = _resolveComponent("AppNumber")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, " Products, " + _toDisplayString(_unref(totalProducts)) + "pc. ", 1 /* TEXT */),
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(" $"),
        _createVNode(_component_AppNumber, {
          input: _unref(totalPrice),
          fixed: 2
        }, null, 8 /* PROPS */, ["input"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_AppNumber, {
          input: -(_unref(totalPrice) - _unref(getPromoPrice)),
          fixed: 2
        }, null, 8 /* PROPS */, ["input"]),
        _createTextVNode("$ ")
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, _unref(isDiscounted)]
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})